<app-skeleton [loading]="loading" height="140px">
    <app-source-detail [baseInfo]="baseInfo"
        [capacityPercentData]="capacityPercentData"
        [detail]="detail"
        [event]="item"
        [loading]="updateLoading"
        icon="#infigo-lunGroup"
        type="lunGroup"
    >
    </app-source-detail>
</app-skeleton>
